module.exports = __webpack_public_path__ + "static/media/Gallery_Slider_5-min.b45061c0.jpg";